export default __webpack_public_path__ + "dabc8dc3dce32d4a6129b5e3838f3376.svg";